
import {Component, Prop, Vue} from "vue-property-decorator";
import {IHome} from "@/modules/Home/interfaces/home.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IAppState} from "@/interfaces/app-state.interface";
import {IApp} from "@/interfaces/app.interface";

  @Component({})
  export default class HomeControls extends Vue {
    @Prop() homeData: IHome.IData;

    pages = IApp.ROUTE_NAME;

    get storeState(): IAppState { return this.$store.state; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }

    async openBalance() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'payment', dialogName: 'balancePopup' });
    }

    async openDeviceStats() {
      await this.$store.dispatch('dialog/openDialog', { blockName: 'allPages', dialogName: 'deviceStatsPopup' });
    }

    async openCarPopup(guestActive) {
      if (!this.userAccess.scCarMk) return;

      await this.$store.dispatch('car/openCarPopup', { carId: null, isGuest: guestActive });
    }

    async openPage(page: IApp.ROUTE_NAME) {
      await this.$store.dispatch('openPage', {routeName: page});
    }
  }
